<template>
	<ModuleCard
		v-if="workflow"
		ref="module_card"
		class="width-100"
		:flowData="workflow"
		:menuItems="menuItems"
		:navigateOnClick="false"
		:showShareButton="false"
		:showActivityStatus="false"
		:showFeatureVisibility="false"
	>
		<template #prepend-inner>
			<AppIcon class="ml-2 drag-handle" name="drag-sign" />
		</template>
	</ModuleCard>
</template>

<script>
import ModuleCard from '@/components/Modules/ModuleCard.vue';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';

export default {
	name: 'ButtonDropdownWorkflowCard',
	components: { ModuleCard },
	props: { workflowId: { type: Number }, hasEditPermissions: { type: Boolean } },
	computed: {
		...mapGettersShorthand({ getWorkflow, selectedProjectId }),
		workflow() {
			return this.getWorkflow(this.workflowId);
		},
		menuItems() {
			return [
				...(this.hasEditPermissions ? [{ text: 'Remove from dropdown', onClick: () => this.$emit('remove') }] : []),
				{
					text: 'Features details',
					onClick: () =>
						this.$router.push({ name: 'FlowDetails', params: { wfID: this.workflowId, projectIdToReturn: this.selectedProjectId } }),
				},
			];
		},
	},
};
</script>
